import React, { useEffect, useState } from 'react';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Avatar,
  Typography,
  TextField,
  Button,
  Box,
  IconButton,
  Divider,
} from '@mui/material';
import Toolbar from "./toolbar"
import CssBaseline from '@mui/material/CssBaseline';
import { Edit, Save, UploadFile } from '@mui/icons-material';
import { Profile,ChangePassword } from "../Model/Auction";
import { getUser } from "../../Model/LocalStorage";
const AccountPage = () => {
  const [editMode, setEditMode] = useState(false);
  const [user, setUser] = useState({
    name: 'Juan Dela Cruz',
    email: 'juan.delacruz@example.com',
    bio: 'Mobile Legends warrior. Coffee addict.',
    avatar: 'https://i.pravatar.cc/150?img=3',
  });


  const [password, setPassword] = useState('');
  const [old_password, setOldPassword] = useState('');
  const [password_confirm, setPasswordConfirm] = useState('')

  const [loading, setLoading] = React.useState(false);

  const getProfile= () => {
    setLoading(true);
    try {
      async function detailsData() {
        const results = await Profile();
        // console.log(results.data)
        results.data.map((val) => {
          setUser(val);
        })

        
        setLoading(false);
        
      }
      detailsData().catch((error) => {
        setLoading(false);
      });
    } catch (error) {}
  };

useEffect(()=>{
  getProfile()
},[])

  const [formData, setFormData] = useState(user);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAvatarUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      setFormData((prev) => ({ ...prev, avatar: reader.result }));
    };
    reader.readAsDataURL(file);
  };

  const handleSave = () => {
    // setUser(formData);
    const Info = {
      "oldPassword": old_password,
      "newpassword": password,
      "confirmPassword":password_confirm
  }
    if(password === password_confirm){
      setEditMode(false);
  
    try {
      async function postData() {
        const results = await ChangePassword(Info);
     
        alert(results.msg)
        
        setLoading(false);
        
      }
      postData().catch((error) => {
        setLoading(false);
      });
    } catch (error) {}
  }else{
    alert("Password and Confirm Password do not match.");
  }
   
  };



  useEffect(() => {
    try {
      // console.log("socket   ",socket.connected)

    async function getUserList() {
      const getuser = await getUser();
            setOldPassword(getuser.drowssap);

    }
    // console.log("socket.connected : ",socket.connected)
    getUserList().catch(console.error);
  } catch (error) {
    // console.log("socket error   ",socket)
  }
  })
  
  return ( 
    <React.Fragment>
    <CssBaseline />
  


    <Container maxWidth="md" sx={{ mt: 6,}}>
    <div>

   
      <Toolbar title={"Profile"}/>
      <Grid container spacing={4} style={{marginTop:40 }}>
        {/* Profile Section */}
        <Grid item xs={12} md={4}>
          <Card sx={{ p: 3, textAlign: 'center', borderRadius: 4 }}>
            <Avatar
              src={formData.avatar}
              sx={{ width: 120, height: 120, margin: '0 auto', mb: 2 }}
            />
            {editMode && (
              <Box>
                <input
                  accept="image/*"
                  id="upload-avatar"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleAvatarUpload}
                />
                <label htmlFor="upload-avatar">
                  <Button
                    variant="outlined"
                    startIcon={<UploadFile />}
                    component="span"
                    size="small"
                  >
                    Upload
                  </Button>
                </label>
              </Box>
            )}
        
            <Typography variant="h6" mt={2}>
              {user.firstname} {user.lastname} 
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user.email}
            </Typography>
          </Card>
        </Grid>

        {/* Account Form Section */}
        <Grid item xs={12} md={8}>
          <Card sx={{ p: 3, borderRadius: 4 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h6">Account Information</Typography>
              <IconButton onClick={() => (editMode ? handleSave() : setEditMode(true))}>
                {editMode ? <Save /> : <Edit />}
              </IconButton>
            </Box>

            <Box component="form" noValidate autoComplete="off">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Full Name"
                    name="name"
                    fullWidth
                    disabled={!editMode}
                    value={user.firstname+' '+user.lastname}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Email"
                    name="email"
                    fullWidth
                    disabled={!editMode}
                    value={user.email}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12}>
                <TextField
                    label="Phone"
                    name="phone"
                    fullWidth
                    disabled={!editMode}
                    value={user.phone}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={handleInputChange}
                  />

                </Grid>
         
              </Grid>


              <Grid container spacing={4} >

              <Grid item xs={12}>
                <div style={{marginTop:20}}>
                <h3>Change Password</h3>   
                </div>

                </Grid>
                <Grid item xs={12}>
  

             
                <TextField
                    label="Password"
                    name="password"
                    fullWidth
                    disabled={!editMode}
                    onChange={(e) =>setPassword(e.target.value)}
                    // value={password}
                  />

                </Grid>

                <Grid item xs={12}>
                <TextField
                    label="Confirm Password"
         
                    fullWidth
                    name="password_confirm"
                    disabled={!editMode}
                    // value={password_confirm}
                    onChange={(e) =>setPasswordConfirm(e.target.value)}
              
                  />

                </Grid>
              </Grid>

              {editMode && (
                <Box textAlign="right" mt={3}>
                  <Button onClick={handleSave} variant="contained">
                    Update Password
                  </Button>
                </Box>
              )}
            </Box>
          </Card>
        </Grid>
      </Grid>
      </div>
    </Container>

    </React.Fragment>
  );
};

export default AccountPage;
